import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { assert } from "@/common/assert";
import platform from "platform";
export function ieVersion() {
  if (platform.name !== "IE") return false;
  var version = Number(platform.version);
  assert(version > 0, "bad ie version: " + platform.version);
  var major = Math.floor(version);
  return major;
}
export function isIe8() {
  var v = ieVersion();
  return v && v === 8;
}